module.exports = __webpack_public_path__ + "templates.collapse-block-46a36a52.html";